import { useRef } from "react";

export default function useSpeaker() {
  const audio = useRef(new Audio());
  const analyser = useRef(null);
  const ctx = useRef(null);

  const ensure = () => {
    if (analyser.current) return;
    ctx.current = new (window.AudioContext || window.webkitAudioContext)();
    const src = ctx.current.createMediaElementSource(audio.current);
    const an = ctx.current.createAnalyser();
    an.fftSize = 512;
    src.connect(an);
    an.connect(ctx.current.destination);
    analyser.current = an;
  };

  const play = (url) =>
    new Promise((resolve, reject) => {
      ensure();
      ctx.current.resume();
      const a = audio.current;
      a.src = url;
      a.onended = resolve;
      a.onerror = reject;
      a.play().catch(reject);
    });

  const stop = () => audio.current.pause();

  return { play, stop, analyser };
}
